// extracted by mini-css-extract-plugin
export default {"container":"WalletItem_container__2J6uR","icon":"WalletItem_icon__LdX-W","name":"WalletItem_name__fgqkw"};